import React from 'react';

import { getStatusText } from 'sharedreact/utils/StatusTextSupport';

import HomeStatusbar from 'workspaces/launcher/components/HomeStatusbar';

type Props = {
  language: string,
  allowMultiSelect: boolean,
  nrOfItemsSelected: number,
  nrOfItems: number,
  stringPrefix: string
};

class AdminStatusbar extends React.Component<Props> {
  override render (): React.ReactNode {
    const {
      language, // eslint-disable-line no-unused-vars
      allowMultiSelect,
      nrOfItemsSelected,
      nrOfItems,
      stringPrefix
    } = this.props;

    const statusText = getStatusText(
      (allowMultiSelect ? nrOfItemsSelected : 0),
      nrOfItems,
      stringPrefix
    );

    return (
      <HomeStatusbar>{statusText}</HomeStatusbar>
    );
  }
}

export default AdminStatusbar;
